import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { Box } from '../../Box/Box.js';
import styled from 'styled-components';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var InputContainerStyled = /*#__PURE__*/styled(Box).withConfig({
  displayName: "Inputstyled__InputContainerStyled",
  componentId: "sc-1yd74ix-0"
})(function (props) {
  return _objectSpread({}, props.$interactiveState);
});
var InputStyled = /*#__PURE__*/styled.input.withConfig({
  displayName: "Inputstyled__InputStyled",
  componentId: "sc-1yd74ix-1"
})({
  opacity: 0,
  margin: 0,
  width: '100%',
  height: '100%',
  cursor: 'inherit',
  position: 'absolute',
  top: 0,
  left: 0,
  zIndex: 1
});
var OverlayStyled = /*#__PURE__*/styled(Box).withConfig({
  displayName: "Inputstyled__OverlayStyled",
  componentId: "sc-1yd74ix-2"
})({
  opacity: 0,
  position: 'absolute',
  width: '30px',
  height: '30px',
  top: '-5px',
  left: '-5px'
});

export { InputContainerStyled, InputStyled, OverlayStyled };
//# sourceMappingURL=Input.styled.js.map
